<div
  class="d-flex justify-content-center align-items-center mt-80"
  style="height: 50vh"
>
  <div class="text-center">
    <h6 style="margin-bottom: 40px">{{ authText.access_denied_text }}</h6>
    <img
      src="./assets/images/access_denied.svg"
      width="200px"
      alt="Access Denied"
    />
    <h6 style="margin-top: 10px">{{ authText.access_denied_caption }}</h6>
    <h6 style="margin-top: 10px">{{ authText.contact_admin }}</h6>
  </div>
</div>
